import { combineReducers } from 'redux';

import * as actionTypes from 'modules/chat/actionTypes';

import loading from 'modules/global/reducers/generic.loading';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   data: Record<string, Record<string, boolean|null>>,
 *   loading: Record<string, boolean>,
 * }} CustomerConversationValidityReducer
 */

const initialState = {
  data: {},
  loading: {},
};

const customerConversationValidityReducer = combineReducers({
  data: createReducer(initialState.data, {
    [actionTypes.CUSTOMER_HAS_VALID_CONVERSATION]: (state, { payload: { dealerId, customerId } }) => ({
      ...state,
      [dealerId]: {
        ...state[dealerId],
        [customerId]: null,
      }
    }),
    [actionTypes.CUSTOMER_HAS_VALID_CONVERSATION_SUCCESS]: (state, { payload, meta: { dealerId, customerId } }) => ({
      ...state,
      [dealerId]: {
        ...state[dealerId],
        [customerId]: Boolean(payload?.conversationId),
      }
    }),
    [actionTypes.CUSTOMER_HAS_VALID_CONVERSATION_FAILURE]: (state, { meta: { dealerId, customerId } }) => ({
      ...state,
      [dealerId]: {
        ...state[dealerId],
        [customerId]: false,
      }
    }),
  }),
  loading: loading(actionTypes.CUSTOMER_HAS_VALID_CONVERSATION),
});

export default customerConversationValidityReducer;
